import { IS_AWS_ENV } from "constants/app.constants";

/** "Max Bin Defaults" (EVA-306): AWS-only, gated on the build-time IS_AWS_ENV check. */
export function useMaxBinDefaults(): Maybe<boolean> {
  return IS_AWS_ENV;
}
